import React, { useEffect, useState, useRef } from 'react';
import { hot } from 'react-hot-loader';
import { translate } from '../../../utils/locale';
import { addEvent, removeEvent } from '../../../utils/dom';
import s from './Customizer.scss';

const Customizer = ({ content, setup }) => {
	const sliderEl = useRef(null);
	const [currentIndex, updateIndex] = useState(0);

	useEffect(() => {
		addEvent(sliderEl.current, 'click.slider', (e) => {
			const direction = window.innerWidth / 2 < e.clientX ? 1 : -1;
			updateIndex((prevIndex) => (prevIndex + content.inserts.length + direction) % content.inserts.length);
		});

		return () => {
			removeEvent(sliderEl.current, 'click.slider');
		};
	});

	return (
		<div ref={sliderEl} className={s.customizer}>
			{ content.header && <h2 className={s.customizer_header}>{ translate(setup, content.header) }</h2> }
			{ content.subtitle && <p className={s.customizer_subtitle}>{ translate(setup, content.subtitle) }</p> }
			{
				content.inserts && (
					<div className={s.customizer_inserts} style={{ width: `${content.inserts.length * 100}%`, transform: `translateX(-${(100 / content.inserts.length) * currentIndex}%)` }}>
						{
							content.inserts.map((insert) => (
								<div className={s.customizer_insert} key={insert.key}>
									<img className={s.customizer_insert_image} src={insert.image.url} alt={insert.image.alt} />
								</div>
							))
						}
					</div>
				)
			}
			{
				content.settings && (
					<div className={s.customizer_settings}>
						{
							content.settings.map((setting, i) => (
								<img className={[s.customizer_setting, (i === currentIndex ? s.is_selected : null)].join(' ')} key={setting.key} src={setting.image.url} alt={setting.image.alt} />
							))
						}
					</div>
				)
			}
		</div>
	);
};

export default hot(module)(Customizer);
